import Image from "next/image";
import React from "react";
import call from "../../public/call.png";
// import agentImage from "../../public/Pic .jpg";
import logo from '../../public/aiproperty-logo.png'
const AgentDetails = () => {
  const openWhatsApp = () => {
    const phoneNumber = "6588772688"; // Without '+'
    const message = encodeURIComponent(
      "Hi Winnie Lim, I am interested in your property listing."
    );

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    window.open(whatsappUrl, "_blank");
  };
  return (
    <div className="bg-white rounded-[20px] border border-[#A3A0B7] h-max">
      <div className="p-5">
        <div className="flex items-center gap-3 mb-4">
          <Image
            src={logo}
            alt="Agent"
            width={60}
            height={60}
            className="rounded-sm"
          />
          <h3 className="text-[20px] leading-[20px] font-bold">
            Get Latest Updates
          </h3>
        </div>
        <p className="text-[#3A3A3A] text-[18px] leading-[30px] mb-4">
          Interested in finding out more about this property? Contact our team to find out more direct information and real-time project updates.
        </p>
        <button
          className="w-full px-3 py-2.5 text-[16px] rounded-full bg-[#24D366] hover:bg-green-700 text-white font-medium mb-4"
          onClick={openWhatsApp}
        >
          WhatsApp Us
        </button>
        <a
          href="tel:+6588772688"
          className="block text-center text-[#0094FF] hover:text-[#0080E0] text-[26px] font-bold tracking-tight transition-colors mb-2"
        >
          +65 8877 2688
        </a>
      </div>
      <div className="py-4 text-[22px] text-[#121212]  text-center bg-[#E9E8ED]  overflow-hidden rounded-b-[20px] hover:bg-[#E6F4FF]">
        AI Property SG
      </div>
    </div>
  );
};

export default AgentDetails;
